import request from './request'
import Vue from 'vue'
import qs from 'qs'

// post
export function postAction(url, parameter) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    method: 'post',
    data: parameter
  })
}
// postParam
export function postParamAction(url, parameter) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    method: 'post',
    params: parameter
  })
}

// putParam
export function putActionParam(url, parameter) {
  return request({
    url: url ,
    method: 'put',
    data: parameter
  })
}

// put
export function putAction(url, parameter) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    method: 'put',
    data:parameter
    // params: parameter
  })
}

// get
export function getAction(url, parameter, headers) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    method: 'get',
    params: parameter,
    headers: headers,
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

// delete
export function deleteAction(url, parameter) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    method: 'DELETE',
    data: parameter,
  })
}

/**
 * @Description: a标签下载文件
 * @param {*}
 * @Date: 2020-10-28 fcc
 */
function downloadFileByA(response, fileInitName) {
  const disposition = (response.headers['content-disposition'] || '').split('filename=')
  let fileName = disposition[disposition.length - 1]
  fileName = decodeURI(fileName).replace(/\++/g, ' ')
  const data = response.data

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(new Blob([data]), fileName || fileInitName)
  } else {
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName || fileInitName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link) // 下载完成移除元素
    window.URL.revokeObjectURL(url) // 释放掉blob对象
  }
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return request({
    url: url + '?t=' + new Date().getTime(),
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}
export function downPostFile(url, parameter) {
  let url1 = url + '?t=' + new Date().getTime()
  if(url.indexOf("?")!=-1){
      url1=url + '&t=' + new Date().getTime()
  }
  return request({
    url: url1,
    data: parameter,
    method: 'POST',
    responseType: 'blob'
  })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then((response) => {
    const data = response.data;
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning('文件下载失败')
      return
    }
    const reader = new FileReader()
    reader.readAsText(data)
    // 处理load事件。该事件在读取操作完成时触发
    reader.onload = e => {
      // const isBlob = true
      try {
        const res = e.target.result
        // if (!res.ok) {
        //   Vue.prototype['$message'].warning('文件下载失败')
        // }else{
          setTimeout(() => {
            downloadFileByA(response, fileName)
          }, 1000)
        // }
      } catch (e) {
        // 经后台返回的文件名截取

      }
    }
  }).catch(err => {
    //console.log(err, '&&&&&&&')
  })
}
